import * as Icons from '@phosphor-icons/react';
import { upperFirst } from 'lodash';
import { stylesheet } from 'typestyle';
import React, { FC } from 'react';

const iconNameToPhosphorIcon: Record<string, string> = {
  box: 'box-arrow-down',
  calendar: 'calendar-blank',
};

const icons = [
  'archive',
  'bag',
  'basket',
  'bell',
  'box',
  'calendar',
  'calendar-check',
  'chat-circle',
  'check-circle',
  'clock-clockwise',
  'cross',
  'cube',
  'drop',
  'envelope',
  'eye',
  'fingerprint',
  'gift',
  'globe',
  'hand-heart',
  'handbag',
  'identification-card',
  'info',
  'leaf',
  'lock',
  'mailbox',
  'navigation-arrow',
  'package',
  'percent',
  'recycle',
  'seal-check',
  'shield-check',
  'star',
  'storefront',
  'tag',
  'thermometer',
  'timer',
  'tree',
  'truck',
  'user-check',
  'user-circle',
  'van',
  'warning',
];

const styles = stylesheet({
  label: {
    display: 'flex',
    gap: 8,
    alignItems: 'center',
  },
});

type CustomIconProps = {
  name: string;
  color: string;
  className?: string;
};

export const CustomIcon: FC<CustomIconProps> = ({ name, ...props }) => {
  const iconName = iconNameToPhosphorIcon[name] || name;
  const parsedName = iconName.split('-').map(upperFirst).join('') + 'Icon';
  const Icon = (Icons as unknown as Record<string, Icons.Icon>)[parsedName];
  if (!Icon) {
    return null;
  }

  return <Icon size={16} weight="light" {...props} />;
};

export const labelIconsOptions = icons.map(value => {
  const label = value.replace(/-/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
  const iconName = iconNameToPhosphorIcon[value] || value;
  return {
    value,
    label: (
      <div className={styles.label}>
        <CustomIcon name={iconName} color="inherit" />
        {label}
      </div>
    ),
  };
});
